import { render, staticRenderFns } from "./MyPopup.vue?vue&type=template&id=76a7bf40&scoped=true"
import script from "./MyPopup.vue?vue&type=script&lang=js"
export * from "./MyPopup.vue?vue&type=script&lang=js"
import style0 from "./MyPopup.vue?vue&type=style&index=0&id=76a7bf40&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76a7bf40",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('76a7bf40')) {
      api.createRecord('76a7bf40', component.options)
    } else {
      api.reload('76a7bf40', component.options)
    }
    module.hot.accept("./MyPopup.vue?vue&type=template&id=76a7bf40&scoped=true", function () {
      api.rerender('76a7bf40', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MyPopup.vue"
export default component.exports